
import {get, first} from "lodash";

export const oktaErrorMessage = (action, unauthMessage = "Username or password is incorrect") => {
    if (get(action.data, "status", "") === "PASSWORD_EXPIRED") {
      return "Your password has been expired.";
    }
    if (get(action.data, "status", "") === "LOCKED_OUT") {
      let autoUnlockMin = get(action.data, "policy.settings.password.lockout.autoUnlockMinutes", " - ");
      return `Your account has been locked out. Try after ${autoUnlockMin} minutes.`;
    }
    if (
      get(action.data, "code", "") === 401 ||
      get(action.data, "message", "").indexOf("401 Unauthorized") > -1
    ) {
      return unauthMessage;
    }
    let errorSummary = get(action.data, "errorSummary", "")
    let errorCause = first(get(action.data, "errorCauses", []));
    return get(errorCause, "errorSummary", errorSummary);
  };